import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">VIX1ON</div>
        
        <p style={{ color: '#8892b0', fontSize: '0.9rem', marginBottom: '10px' }}>
          Student Class of <strong>MAIT Insan Kamil Sidoarjo</strong>
        </p> 
        
        <div className="copyright">
          <p>&copy; {new Date().getFullYear()} VIX1ON Class. All Rights Reserved.</p>
        </div>

        <div className="social-links-minimal">
          <a 
            href="https://www.instagram.com/vi.x1on/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="instagram-icon-only"
          >
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;